import { notification } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";

/**
 * Notification Service
 * Handles all in-app and email notifications
 */

const NotificationService = {
  /**
   * Show seller request approved notification
   * @param {string} sellerName - Name of the seller
   * @param {string} shopName - Name of the shop
   */
  sellerApproved: (sellerName, shopName) => {
    notification.success({
      message: "Seller Request Approved! 🎉",
      description: `Welcome ${sellerName}! Your shop "${shopName}" has been approved. You can now log in as a seller and start listing your products.`,
      duration: 0,
      icon: <CheckCircleOutlined style={{ color: "#22c55e" }} />,
      placement: "topRight",
    });
  },

  /**
   * Show seller request rejected notification
   * @param {string} sellerName - Name of the seller
   * @param {string} reason - Reason for rejection
   */
  sellerRejected: (sellerName, reason) => {
    notification.error({
      message: "Seller Request Rejected",
      description: `Hi ${sellerName}, we're unable to approve your seller request at this time. ${
        reason ? `Reason: ${reason}` : "Please review your application and try again."
      }`,
      duration: 0,
      placement: "topRight",
    });
  },

  /**
   * Show pending application notification
   */
  applicationPending: () => {
    notification.info({
      message: "Application Pending",
      description:
        "Your seller application is being reviewed. We'll notify you as soon as there's an update.",
      duration: 4.5,
      placement: "topRight",
    });
  },

  /**
   * Show seller registration submitted notification
   */
  registrationSubmitted: () => {
    notification.success({
      message: "Registration Submitted",
      description:
        "Your seller registration has been submitted. Please wait for admin approval.",
      duration: 4.5,
      placement: "topRight",
    });
  },

  /**
   * Show generic success notification
   * @param {string} message - Notification message
   * @param {string} description - Notification description
   */
  success: (message, description) => {
    notification.success({
      message,
      description,
      placement: "topRight",
    });
  },

  /**
   * Show generic error notification
   * @param {string} message - Notification message
   * @param {string} description - Notification description
   */
  error: (message, description) => {
    notification.error({
      message,
      description,
      placement: "topRight",
    });
  },

  /**
   * Show generic warning notification
   * @param {string} message - Notification message
   * @param {string} description - Notification description
   */
  warning: (message, description) => {
    notification.warning({
      message,
      description,
      placement: "topRight",
    });
  },

  /**
   * Show generic info notification
   * @param {string} message - Notification message
   * @param {string} description - Notification description
   */
  info: (message, description) => {
    notification.info({
      message,
      description,
      placement: "topRight",
    });
  },
};

export default NotificationService;
